<template>
    <div>
        <div class="main__filters overflow-a pt-29 sm:pt-13 md:pt-21 pb-32 lg:py-0" id="main_filters">
            <div class="block info-ad mb-4 md:mb-0">
                <div class="info-content">
                    <p class="tx-20">
                        Estás viendo <strong>autos nuevos</strong>
                            <a href="/catalogo" class="btn btn--next-ad px-4 tx-14 mr-2 mt-4">
                                <p class="m-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 512 512">
                                        <path d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/>
                                    </svg>
                                    Cambiar a Seminuevos
                                </p>
                            </a>
                    </p>

                </div>
            </div>
            <div class="px-3 py-4 lg:px-0 lg:pt-0">
                <p class="tx-14 md:tx-18 tx-grey-1 mb-2 text-left"> Búsquedad avanzada </p>
            </div>
            <agency-filter-condition-component v-if="dealerUser" @change="updateFilter" ref="condition"> </agency-filter-condition-component>

            <div class="box box--white">
                <!-- <div class="filters__bit lg:hidden"> -->
                    <!-- <orderby-component :type="'small'" ref="searchOrder"></orderby-component> -->
                      <!-- <select v-model="filters.orderby" class="form-input" name="order_by"> -->
                        <!-- <option hidden selected> Ordenar por </option> -->
                        <!-- <option selected value="1">Más recientes</option> -->
                        <!-- <option value="2">Más antiguos</option> -->
                        <!-- <option value="3">Mayor precio</option> -->
                        <!-- <option value="4">Menor precio</option> -->
                        <!-- <option value="5">Aleatorio</option> -->
                    <!-- </select> -->
                <!-- </div> -->

            <filter-model-component @change="updateFilter" ref="model" ></filter-model-component>
            <filter-brand-component  @change="updateFilter" ref="brand"></filter-brand-component>
            <filter-state-component @change="updateFilter" ref="state"></filter-state-component>

            <filter-dealership-component @change="updateFilter"
            ref="dealership" v-for="(state_id, key) in filters.states" :key="state_id" :index="key" :state_id="state_id">
            </filter-dealership-component>

            <filter-price-component @change="updateFilter" ref="price"></filter-price-component>

            <filter-year-component @change="updateFilter" ref="year" :inventoryYears="inventoryYears"></filter-year-component>


            </div>

            <filter-car-type-component @change="updateFilter" ref="car_type"></filter-car-type-component>
        </div>
        <a v-if="ad" id="ad" :href="ad.redirect_to" class="mt-4">
            <img class="mt-4" :src="adImageUrl" alt="Ad" style="max-height: 520px;">
        </a>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import OrderbyComponent from './OrderbyComponent.vue';
import AgencyFilterConditionComponent from './partials/filters/AgencyFilterConditionComponent.vue';
import FilterYearComponent from './partials/filters/FilterYearComponent.vue';
import FilterPriceComponent from './partials/filters/FilterPriceComponent.vue';
import FilterBrandComponent from './partials/filters/FilterBrandComponent.vue';
import FilterModelComponent from './partials/filters/FilterModelComponent.vue';
import FilterStateComponent from './partials/filters/FilterStateComponent.vue';
import FilterDealershipComponent from './partials/filters/FilterDealershipComponent.vue';
import FilterCarTypeComponent from './partials/filters/FilterCarTypeComponent.vue';
export default {
    props: {
        dealerUser : Object,
        selectOrder: Number,
        inventoryYears: {
            type: Array,
            default: []
        },
        ad: {
            type: Object,
        }
    },

    data: () => ({
        filterEvent: false,
        currentSearch: '',
        filters: {
            kilometers: {
                from: 0,
                to  : 0
            },
            prices: {
                from: 0,
                to  : 0
            },
            years: [],
            plus: {
                one_owner  : false,
                invoice    : false,
                user_verify: false,
            },
            states:[],
            dealerships: [],
            brands: [],
            colors: [],
            models: [],
            transmissions: [],
            conditions: [],
            types_car: [],
            user_type: [],
            score: [],
            orderby: null,
            search: '',
            search_word: ''
        },
        formData: null
    }),

    components: {
        'filter-state-component': FilterStateComponent,
        'filter-dealership-component': FilterDealershipComponent,
        'agency-filter-condition-component': AgencyFilterConditionComponent,
        'filter-year-component': FilterYearComponent,
        'filter-price-component': FilterPriceComponent,
        'filter-brand-component': FilterBrandComponent,
        'filter-model-component': FilterModelComponent,
        'orderby-component' : OrderbyComponent,
        'filter-car-type-component': FilterCarTypeComponent
    },
    computed : {
        adImageUrl() {
            return `${process.env.MIX_API_SUBASTALO_URL}/storage/marketplace/banners/catalogs/${this.ad.image}`
        },
        apiFilters() {
            if(this.dealerUser) {
                return`/agencia/${this.dealerUser.id}/filters?${this.currentSearch}`;
            }
            return`/catalogo/filters?${this.currentSearch}`
        },
        isOnlySearchingForNew() {
            if(this.filters.conditions.length === 0){
                return false;
            }
            return  this.filters.conditions.reduce((acc, val) => acc + val) === 1;
        },
    },
    mounted() {
        let vm = this;
        vm.getFiltersStore();

        var waitModels = setInterval( function() {
            if ( vm.filters.models.length > 0 && !!vm.$refs.model ) {

                _.forEach(vm.$refs.model, function(reference) {
                    reference.filters = vm.filters.models;
                });
                clearInterval(waitModels);
            }

        }, 1000);

        var waitDealerships = setInterval( function() {
            if ( vm.filters.dealerships.length > 0 && !!vm.$refs.dealership ) {

                _.forEach(vm.$refs.dealership, function(reference) {
                    reference.filters = vm.filters.dealerships;
                });
                clearInterval(waitDealerships);
            }

        }, 1000);
    },

    watch: {
        'selectOrder': {
            handler(order) {
                this.filters.orderby = order;
            },
        },
        'filters.orderby': {
            handler(newValue, oldValue){
                if (this.selectOrder != newValue ) {
                    this.$emit('orderEdit', newValue );
                }
                if ( this.selectOrder != oldValue ) {
                    this.getFiltersAsync()
                }
            }
        },
        'filters.search': {
            handler(newValue, oldValue){
                if (oldValue != '' && newValue == '') {
                    this.getFiltersAsync()
                }
            }
        },
    },

    methods: {
        ...mapActions('catalogNewVehicle',['getFiltersByUrl']),

        getFiltersStore () {
            let vm = this;
            vm.getFiltersByUrl();
            let state = vm.$store.state.catalogNewVehicle.filters;
            vm.$refs.state.filters = vm.filters.states = state.states;

            vm.filters.dealerships = state.dealerships;

            vm.$refs.year.filters       = state.years;
            vm.$refs.brand.filters = vm.filters.brands = state.brands;
            vm.filters.models           = state.models;

            vm.$refs.price.filters      = state.prices;
            vm.$refs.price.prices_from  = parseInt(state.prices.from);
            vm.$refs.price.prices_to    = parseInt(state.prices.to);

            vm.filters.search  = state.search;
            vm.filters.page    = state.page;
            vm.filters.orderby = state.orderby;
            vm.filters.search_word = state.search_word;
            vm.$refs.car_type.filters   = state.types_car;
        },

        setQueryToLocation() {
            let vm = this;
            let CurrentUrl  = window.location.origin + window.location.pathname;
            var urlParams   = new URLSearchParams();
            if ( !!vm.filters["states"] && vm.filters["states"].length > 0 ) {
                var value = Array.isArray(vm.filters["states"]) ? vm.filters["states"].join(',') : vm.filters["states"];
                urlParams.set('states', value );
            }

            if ( !!vm.filters["dealerships"] && vm.filters["dealerships"].length > 0 ) {
                urlParams.set('dealerships', vm.filters["dealerships"].join(','));
            }
            if ( !!vm.filters["brands"] && vm.filters["brands"].length > 0 ) {
                var value = Array.isArray(vm.filters["brands"]) ? vm.filters["brands"].join(',') : vm.filters["brands"];
                urlParams.set('brands', value );
            }
            if ( !!vm.filters["models"] && vm.filters["models"].length > 0  ) {
                var value = Array.isArray(vm.filters["models"]) ? vm.filters["models"].join(',') : vm.filters["models"];
                urlParams.set('models', value );
            }
            if ( !!vm.filters["orderby"] ) {
                urlParams.set('orderby', vm.filters["orderby"] );
            if ( !!vm.filters["search_word"] ) {
                urlParams.set('search_word', vm.filters["search_word"] );
            }
            }
            if ( !!vm.filters["page"] ) {
                urlParams.set('page', vm.filters["page"] );
            }
            if ( !!vm.filters["search"] ) {
                urlParams.set('search', vm.filters["search"] );
            }
            if ( !!vm.filters["prices"]['from'] || !!vm.filters["prices"]['to']  ) {
                urlParams.set('prices', 'from:' + vm.filters["prices"]['from'] + ',to:' + vm.filters["prices"]['to'] );
            }
            if ( !!vm.filters["years"] && vm.filters["years"].length > 0 ) {
                var value = Array.isArray(vm.filters["years"]) ? vm.filters["years"].join(',') : vm.filters["years"];
                urlParams.set('years', value );
            }
            if ( !!vm.filters["types_car"] && vm.filters["types_car"].length > 0  ) {
                var value = Array.isArray(vm.filters["types_car"]) ? vm.filters["types_car"].join(',') : vm.filters["types_car"];
                urlParams.set('types', value );
            }

            const url = new URL(window.location.href);
            if(url.searchParams.get("size") != null) {
                urlParams.set('size', url.searchParams.get("size") );
            }
            else {
                urlParams.set('size', 24 );
            }
            vm.currentSearch = urlParams.toString();
            history.replaceState(
                { page: 1 },
                "Búsqueda página " + vm.filters['page'],
                CurrentUrl + "?" + vm.currentSearch
            );
        },

        async getFiltersAsync() {
            let vm = this;
            if ( !vm.filterEvent ) {
                vm.filterEvent = true;
                try {
                    const filters = window.location.search
                    const url = `/nuevos/catalogo/filters${filters}`
                    const { data } = await axios.get(url)
                    vm.$emit('newResults', {
                        products: data.products,
                        lastPage: data.lastPage,
                        currentPage: data.currentPage,
                        total: data.total
                    });

                    vm.filterEvent = false;
                    window.scrollTo({top: 0, behavior: 'smooth'});
                } catch (error) {
                    vm.filterEvent = false;
                    console.error(error);
                }
            }
        },

        updateFilter(filter, value) {
            this.filters[filter] = value
            if(filter == 'states' && value.length == 0) this.filters.dealerships = []
            if (filter == 'brands') {
                this.$store.dispatch('catalogNewVehicle/updateModelsFilter', value)
            }
            this.setQueryToLocation()
            this.getFiltersAsync()

            this.$emit('filters', this.filters)
        }
    },
    created(){
        this.getFiltersAsync()
    }
}
</script>
<style scoped>
#ad {
    display: none;
}
@media screen and (min-width: 1280px) {
    #ad {
        display: block;
    }
}
</style>
